<template>
    <code
        class="rounded-md bg-surface--light p-1 text-sm text-secondary"
        data-spec-class="code"
    >
        <slot />
    </code>
</template>

<script setup lang="ts"></script>
